// Underground space factor — rules/FACTOR_TABLES_MVP.md §7.

import type { UndergroundType } from "../types/enums.js";

export const UNDERGROUND_SPACE_TABLE: Readonly<Record<UndergroundType, number>> = {
  交通设施或综合管廊: 0.1,
  其他地下空间: 0.3,
};
